import { c as _c } from "react/compiler-runtime";
import cn from 'classnames';
import type { ComponentPropsWithoutRef } from 'react';
import { trackNavigationHeaderClick } from '../../../../shared';
type NavigationItemLabelProps = {
  emphasis?: 'default' | 'promotion';
  href?: string;
  openInNewTab?: boolean;
  title: string;
} & Omit<ComponentPropsWithoutRef<'a'>, 'children' | 'className' | 'href'>;
export function NavigationItemLabel(t0) {
  const $ = _c(25);
  let emphasis;
  let href;
  let onClick;
  let openInNewTab;
  let props;
  let title;
  if ($[0] !== t0) {
    ({
      emphasis,
      href,
      openInNewTab,
      title,
      onClick,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = emphasis;
    $[2] = href;
    $[3] = onClick;
    $[4] = openInNewTab;
    $[5] = props;
    $[6] = title;
  } else {
    emphasis = $[1];
    href = $[2];
    onClick = $[3];
    openInNewTab = $[4];
    props = $[5];
    title = $[6];
  }
  const t1 = emphasis === "promotion";
  let t2;
  if ($[7] !== t1) {
    t2 = cn("desktop-menu__link", {
      "desktop-menu__link--sale": t1
    });
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const className = t2;
  if (!href) {
    let t3;
    if ($[9] !== className || $[10] !== props || $[11] !== title) {
      t3 = <span {...props} className={className}>{title}</span>;
      $[9] = className;
      $[10] = props;
      $[11] = title;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    return t3;
  }
  const t3 = openInNewTab ? "noopener noreferrer" : undefined;
  const t4 = openInNewTab ? "_blank" : undefined;
  let t5;
  if ($[13] !== href || $[14] !== onClick || $[15] !== title) {
    t5 = event => {
      trackNavigationHeaderClick({
        selection: [title],
        linkUrl: href,
        navSection: "main nav"
      });
      onClick?.(event);
    };
    $[13] = href;
    $[14] = onClick;
    $[15] = title;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== className || $[18] !== href || $[19] !== props || $[20] !== t3 || $[21] !== t4 || $[22] !== t5 || $[23] !== title) {
    t6 = <a {...props} href={href} className={className} rel={t3} target={t4} onClick={t5}>{title}</a>;
    $[17] = className;
    $[18] = href;
    $[19] = props;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = title;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  return t6;
}